<template>
  <div
    v-if="question"
    :id="`question_field_${question.id}`"
    class="form-question w-148 py-6 flex flex-col items-center bg-pure-white border-l-8 border-lime-500 rounded-xl"
  >
    <div class="w-128 mb-2 flex">
      <div class="flex-shrink-0 -mx-2">
        <BlSelectBox
          placeholder="Select input type"
          v-model="inputTypeInput"
          :options="inputTypeOptions"
          @change="inputTypeInput = $event"
          dense
          borderless
        />
      </div>
    </div>
    <!-- <input
      type="text"
      :name="`question_label_${question.id}`"
      :id="`question_label_${question.id}`"
      class="label-input mb-2 focus:border-light-purple"
      placeholder="Question label"
      v-model="labelInput"
    /> -->
    <textarea
      type="text"
      :name="`question_label_${question.id}`"
      :id="`question_label_${question.id}`"
      class="label-area-input mb-2 focus:border-light-purple"
      placeholder="Question label"
      v-model="labelInput"
    ></textarea>
    <div class="mb-3">
      <div
        v-if="inputTypeInput === 'text'"
        class="h-7.5 w-128 px-2 flex items-center rounded border border-slate-500 bg-slate-200"
      >
        <BlTextBody2 text="The guardian will fill in the answer here." />
      </div>
      <div
        v-if="inputTypeInput === 'textarea'"
        class="h-25 w-128 py-1 px-2 rounded border border-slate-500 bg-slate-200"
      >
        <BlTextBody2 text="The guardian will fill in the answer here." />
      </div>
      <div
        v-if="inputTypeInput === 'date'"
        class="h-7.5 w-128 px-2 flex items-center rounded border border-slate-500 bg-slate-200"
      >
        <BlTextBody2 text="dd/mm/yyyy" />
      </div>
      <div
        v-if="inputTypeInput === 'radio' || inputTypeInput === 'checkbox'"
        class="w-128 flex flex-col gap-2"
      >
        <div
          v-for="(opt, idx) in inputOptionsInput"
          :key="idx"
          class="relative flex items-center gap-2"
        >
          <BlInputRadio
            v-if="inputTypeInput === 'radio'"
            :name="`options_input_${question.id}_${idx}`"
          />
          <BlInputCheck
            v-if="inputTypeInput === 'checkbox'"
            :name="`options_input_${question.id}_${idx}`"
          />
          <input
            type="text"
            :name="`options_label_${question.id}_${idx}`"
            :id="`options_label_${question.id}_${idx}`"
            class="option-label-input focus:border-light-purple"
            placeholder="Type the option here"
            :value="inputOptionsInput[idx]"
            @input="onInputOption(idx, opt, $event.target.value)"
          />
          <BlInputButton
            type="outlined-error"
            dense
            icon="delete"
            @clicked="onRemoveOption(idx)"
          />
        </div>
        <div v-if="isUseOtherInput" class="flex items-center gap-2">
          <BlInputRadio
            v-if="inputTypeInput === 'radio'"
            :name="`options_input_${question.id}_other`"
          />
          <BlInputCheck
            v-if="inputTypeInput === 'checkbox'"
            :name="`options_input_${question.id}_other`"
          />
          <BlTextBody2 text="Other:" class="text-slate-800" />
          <div
            class="h-7.5 px-2 flex items-center rounded border border-slate-500 bg-slate-200"
            :style="{ width: '27.5rem' }"
          >
            <BlTextBody2 text="The guardian will fill in the answer here." />
          </div>
          <BlInputButton
            type="outlined-error"
            dense
            icon="delete"
            @clicked="onRemoveUseOther"
          />
        </div>
        <div class="h-7.5 flex items-center gap-2">
          <div class="cursor-pointer" @click="addOption">
            <BlTextSubtitle3
              text="Add option"
              class="h-7.5 flex items-center text-light-purple hover:text-dark-purple-200"
            />
          </div>
          <BlTextBody2
            v-if="!isUseOtherInput"
            text="or"
            class="text-slate-800"
          />
          <div
            v-if="!isUseOtherInput"
            class="cursor-pointer"
            @click="addUseOther"
          >
            <BlTextSubtitle3
              text="Add Other"
              class="h-7.5 flex items-center text-light-purple hover:text-dark-purple-200"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="question.data_field"
      class="w-128 flex items-center justify-start flex-wrap gap-2"
    >
      <BlTextBody2 text="The answer will be recorded in the" />
      <div class="h-5.5 px-1.5 flex items-center rounded bg-slate-300">
        <BlTextBody2 :text="question.data_field.label" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import debounce from "lodash/debounce";

import BlIcon from "../../../BlIcon.vue";
import BlTextSubtitle3 from "../../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../../BlTextBody2.vue";
import BlSelectBox from "../../../BlSelectBox.vue";
import BlInputRadio from "../../../BlInputRadio.vue";
import BlInputCheck from "../../../BlInputCheck.vue";
import BlInputButton from "../../../BlInputButton.vue";

export default {
  name: "ParentFormQuestion",
  components: {
    BlIcon,
    BlTextSubtitle3,
    BlTextBody2,
    BlSelectBox,
    BlInputRadio,
    BlInputCheck,
    BlInputButton
  },
  props: {
    question: { type: Object, required: true }
  },
  data() {
    const shortAnswer = `<svg class="bl-svg-filled h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="bl-svg-filled-main" d="M2 4C2 3.86739 2.05268 3.74021 2.14645 3.64645C2.24021 3.55268 2.36739 3.5 2.5 3.5H13.5C13.6326 3.5 13.7598 3.55268 13.8536 3.64645C13.9473 3.74021 14 3.86739 14 4C14 4.13261 13.9473 4.25979 13.8536 4.35355C13.7598 4.44732 13.6326 4.5 13.5 4.5H2.5C2.36739 4.5 2.24021 4.44732 2.14645 4.35355C2.05268 4.25979 2 4.13261 2 4ZM7.5 6H2.5C2.36739 6 2.24021 6.05268 2.14645 6.14645C2.05268 6.24021 2 6.36739 2 6.5C2 6.63261 2.05268 6.75979 2.14645 6.85355C2.24021 6.94732 2.36739 7 2.5 7H7.5C7.63261 7 7.75979 6.94732 7.85355 6.85355C7.94732 6.75979 8 6.63261 8 6.5C8 6.36739 7.94732 6.24021 7.85355 6.14645C7.75979 6.05268 7.63261 6 7.5 6Z" fill="white"/></svg>`;
    const longParagraph = `<svg class="bl-svg-filled h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="bl-svg-filled-main" d="M2 4C2 3.86739 2.05268 3.74021 2.14645 3.64645C2.24021 3.55268 2.36739 3.5 2.5 3.5H13.5C13.6326 3.5 13.7598 3.55268 13.8536 3.64645C13.9473 3.74021 14 3.86739 14 4C14 4.13261 13.9473 4.25979 13.8536 4.35355C13.7598 4.44732 13.6326 4.5 13.5 4.5H2.5C2.36739 4.5 2.24021 4.44732 2.14645 4.35355C2.05268 4.25979 2 4.13261 2 4ZM13.5 6H2.5C2.36739 6 2.24021 6.05268 2.14645 6.14645C2.05268 6.24021 2 6.36739 2 6.5C2 6.63261 2.05268 6.75979 2.14645 6.85355C2.24021 6.94732 2.36739 7 2.5 7H13.5C13.6326 7 13.7598 6.94732 13.8536 6.85355C13.9473 6.75979 14 6.63261 14 6.5C14 6.36739 13.9473 6.24021 13.8536 6.14645C13.7598 6.05268 13.6326 6 13.5 6ZM13.5 8.5H2.5C2.36739 8.5 2.24021 8.55268 2.14645 8.64645C2.05268 8.74021 2 8.86739 2 9C2 9.13261 2.05268 9.25979 2.14645 9.35355C2.24021 9.44732 2.36739 9.5 2.5 9.5H13.5C13.6326 9.5 13.7598 9.44732 13.8536 9.35355C13.9473 9.25979 14 9.13261 14 9C14 8.86739 13.9473 8.74021 13.8536 8.64645C13.7598 8.55268 13.6326 8.5 13.5 8.5ZM9 11H2.5C2.36739 11 2.24021 11.0527 2.14645 11.1464C2.05268 11.2402 2 11.3674 2 11.5C2 11.6326 2.05268 11.7598 2.14645 11.8536C2.24021 11.9473 2.36739 12 2.5 12H9C9.13261 12 9.25979 11.9473 9.35355 11.8536C9.44732 11.7598 9.5 11.6326 9.5 11.5C9.5 11.3674 9.44732 11.2402 9.35355 11.1464C9.25979 11.0527 9.13261 11 9 11Z" fill="white"/></svg>`;
    const date = `<svg class="bl-svg-filled h-4 w-4" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="bl-svg-filled-main" d="M19.5 3H17.25V2.25C17.25 2.05109 17.171 1.86032 17.0303 1.71967C16.8897 1.57902 16.6989 1.5 16.5 1.5C16.3011 1.5 16.1103 1.57902 15.9697 1.71967C15.829 1.86032 15.75 2.05109 15.75 2.25V3H8.25V2.25C8.25 2.05109 8.17098 1.86032 8.03033 1.71967C7.88968 1.57902 7.69891 1.5 7.5 1.5C7.30109 1.5 7.11032 1.57902 6.96967 1.71967C6.82902 1.86032 6.75 2.05109 6.75 2.25V3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM6.75 4.5V5.25C6.75 5.44891 6.82902 5.63968 6.96967 5.78033C7.11032 5.92098 7.30109 6 7.5 6C7.69891 6 7.88968 5.92098 8.03033 5.78033C8.17098 5.63968 8.25 5.44891 8.25 5.25V4.5H15.75V5.25C15.75 5.44891 15.829 5.63968 15.9697 5.78033C16.1103 5.92098 16.3011 6 16.5 6C16.6989 6 16.8897 5.92098 17.0303 5.78033C17.171 5.63968 17.25 5.44891 17.25 5.25V4.5H19.5V7.5H4.5V4.5H6.75ZM19.5 19.5H4.5V9H19.5V19.5Z" fill="white"/></svg>`;
    const radioButton = `<svg class="bl-svg-filled h-4 w-4" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="bl-svg-filled-main" d="M8 11C8.79565 11 9.55871 10.6839 10.1213 10.1213C10.6839 9.55871 11 8.79565 11 8C11 7.20435 10.6839 6.44129 10.1213 5.87868C9.55871 5.31607 8.79565 5 8 5C7.20435 5 6.44129 5.31607 5.87868 5.87868C5.31607 6.44129 5 7.20435 5 8C5 8.79565 5.31607 9.55871 5.87868 10.1213C6.44129 10.6839 7.20435 11 8 11ZM8 2C7.21207 2 6.43185 2.15519 5.7039 2.45672C4.97595 2.75825 4.31451 3.20021 3.75736 3.75736C3.20021 4.31451 2.75825 4.97595 2.45672 5.7039C2.15519 6.43185 2 7.21207 2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C9.5913 14 11.1174 13.3679 12.2426 12.2426C13.3679 11.1174 14 9.5913 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2ZM3 8C3 6.67392 3.52678 5.40215 4.46447 4.46447C5.40215 3.52678 6.67392 3 8 3C9.32608 3 10.5979 3.52678 11.5355 4.46447C12.4732 5.40215 13 6.67392 13 8C13 9.32608 12.4732 10.5979 11.5355 11.5355C10.5979 12.4732 9.32608 13 8 13C6.67392 13 5.40215 12.4732 4.46447 11.5355C3.52678 10.5979 3 9.32608 3 8Z" fill="white"/></svg>`;
    const toDo = `<svg class="bl-svg-filled h-4 w-4" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="bl-svg-filled-main" d="M13.5672 7.68281C13.6253 7.74086 13.6714 7.80979 13.7029 7.88566C13.7343 7.96154 13.7505 8.04287 13.7505 8.125C13.7505 8.20713 13.7343 8.28846 13.7029 8.36434C13.6714 8.44021 13.6253 8.50914 13.5672 8.56719L9.19219 12.9422C9.13414 13.0003 9.06521 13.0464 8.98934 13.0779C8.91346 13.1093 8.83213 13.1255 8.75 13.1255C8.66787 13.1255 8.58654 13.1093 8.51066 13.0779C8.43479 13.0464 8.36586 13.0003 8.30781 12.9422L6.43281 11.0672C6.31554 10.9499 6.24965 10.7909 6.24965 10.625C6.24965 10.4591 6.31554 10.3001 6.43281 10.1828C6.55009 10.0655 6.70915 9.99965 6.875 9.99965C7.04085 9.99965 7.19991 10.0655 7.31719 10.1828L8.75 11.6164L12.6828 7.68281C12.7409 7.6247 12.8098 7.5786 12.8857 7.54715C12.9615 7.5157 13.0429 7.49951 13.125 7.49951C13.2071 7.49951 13.2885 7.5157 13.3643 7.54715C13.4402 7.5786 13.5091 7.6247 13.5672 7.68281ZM17.5 3.75V16.25C17.5 16.5815 17.3683 16.8995 17.1339 17.1339C16.8995 17.3683 16.5815 17.5 16.25 17.5H3.75C3.41848 17.5 3.10054 17.3683 2.86612 17.1339C2.6317 16.8995 2.5 16.5815 2.5 16.25V3.75C2.5 3.41848 2.6317 3.10054 2.86612 2.86612C3.10054 2.6317 3.41848 2.5 3.75 2.5H16.25C16.5815 2.5 16.8995 2.6317 17.1339 2.86612C17.3683 3.10054 17.5 3.41848 17.5 3.75ZM16.25 16.25V3.75H3.75V16.25H16.25Z" fill="white"/></svg>`;
    return {
      saveLoading: false,
      inputTypeInput: "",
      inputTypeOptions: [
        {
          value: "text",
          label: "Short answer",
          prefix: `<div class="h-6 w-6 flex items-center justify-center rounded bg-lime-500">${shortAnswer}</div>`
        },
        {
          value: "textarea",
          label: "Paragraph",
          prefix: `<div class="h-6 w-6 flex items-center justify-center rounded bg-lime-500">${longParagraph}</div>`
        },
        {
          value: "date",
          label: "Date",
          prefix: `<div class="h-6 w-6 flex items-center justify-center rounded bg-lime-500">${date}</div>`
        },
        {
          value: "radio",
          label: "Multiple choice",
          prefix: `<div class="h-6 w-6 flex items-center justify-center rounded bg-lime-500">${radioButton}</div>`
        },
        {
          value: "checkbox",
          label: "Checkboxes",
          prefix: `<div class="h-6 w-6 flex items-center justify-center rounded bg-lime-500">${toDo}</div>`
        }
      ],
      labelInput: "",
      inputOptionsInput: [],
      isUseOtherInput: false
    };
  },
  watch: {
    inputTypeInput(val) {
      if (val && val !== this.question.input_type) {
        this.onEditing();
      }
    },
    labelInput(val) {
      if (val && val !== this.question.label) {
        this.onEditing();
      }
    }
  },
  mounted() {
    this.inputTypeInput = this.question.input_type;
    this.labelInput = this.question.label;
    this.inputOptionsInput = this.question.input_options || [];
    this.isUseOtherInput = this.question.is_use_other || false;
  },
  methods: {
    ...mapActions(["updateParentFormQestion"]),
    onInputOption(idx, opt, val) {
      if (opt !== val) {
        this.inputOptionsInput[idx] = val;
        this.onEditing();
      }
    },
    onRemoveOption(idx) {
      this.inputOptionsInput.splice(idx, 1);
      this.onEditing();
    },
    addOption() {
      this.inputOptionsInput = [...this.inputOptionsInput, ""];
    },
    onRemoveUseOther() {
      this.isUseOtherInput = false;
      this.onEditing();
    },
    addUseOther() {
      this.isUseOtherInput = true;
      this.onEditing();
    },
    onEditing: debounce(function() {
      const data = {
        id: this.question.id,
        question: {
          label: this.labelInput,
          input_type: this.inputTypeInput,
          input_options: this.inputOptionsInput,
          is_use_other: this.isUseOtherInput
        }
      };
      this.saveLoading = true;
      this.updateParentFormQestion(data).then(({ success }) => {
        this.saveLoading = false;
        if (!success) {
          this.inputTypeInput = this.question.input_type;
          this.labelInput = this.question.label;
          this.inputOptionsInput = this.question.input_options || [];
          this.isUseOtherInput = this.question.is_use_other || false;
          // return;
        }
      });
    }, 1000)
  }
};
</script>

<style scoped lang="scss">
.form-question {
  .label-input {
    width: 32rem;
    height: 2rem;
    padding: 4px 8px 4px 8px;
    border-radius: 5px;
    border: 1px solid var(--Slate-5, #d0d5dd);
    //
    font-size: 1rem;
    font-weight: 700;
    line-height: 2rem;
    letter-spacing: 0.5px;
    text-align: left;
    color: var(--Slate-10, #1d2939);
    //
    outline: none;
  }
  .label-area-input {
    width: 32rem;
    height: 2.75rem;
    padding: 4px 8px 4px 8px;
    border-radius: 5px;
    border: 1px solid var(--Slate-5, #d0d5dd);
    //
    font-size: 1rem;
    font-weight: 700;
    line-height: 2rem;
    letter-spacing: 0.5px;
    text-align: left;
    color: var(--Slate-10, #1d2939);
    //
    outline: none;
  }

  .option-label-input {
    width: 30.5rem;
    height: 1.875rem;
    padding: 4px 8px 4px 8px;
    border-radius: 5px;
    border: 1px solid var(--Slate-5, #d0d5dd);
    //
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: 0.5px;
    text-align: left;
    color: var(--Slate-8, #475467);
    //
    outline: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/center/salesPipeline/parentForm/Question.vue